<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
  @if (tracks.length) {
    @for (track of tracks; track track) {
      <bmcore-track-item-box ngxSlickItem class="slide" [track]="track" [tracks]="tracks"> </bmcore-track-item-box>
    }
  }

  @if (producers.length) {
    @for (producer of producers; track producer) {
      <bmcore-producer-item ngxSlickItem class="slide" [producer]="producer"> </bmcore-producer-item>
    }
  }
</ngx-slick-carousel>
